"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newInsightWidget = exports.InsightWidgetBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var widgetFactory_1 = require("./widgetFactory");
/**
 * @alpha
 */
var InsightWidgetBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(InsightWidgetBuilder, _super);
    function InsightWidgetBuilder(item, validator) {
        var _this = _super.call(this, item, validator) || this;
        _this.item = item;
        _this.validator = validator;
        _this.drills = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("drills", valueOrUpdateCallback);
        };
        _this.insight = function (valueOrUpdateCallback) {
            return _this.setWidgetProp("insight", valueOrUpdateCallback);
        };
        _this.properties = function (valueOrUpdateCallback) { return _this.setWidgetProp("properties", valueOrUpdateCallback); };
        return _this;
    }
    InsightWidgetBuilder.for = function (insightWidget) {
        ts_invariant_1.default(sdk_backend_spi_1.isInsightWidgetDefinition(insightWidget) || sdk_backend_spi_1.isInsightWidget(insightWidget), "Provided data must be IInsightWidget or IInsightWidgetDefinition!");
        return new InsightWidgetBuilder(insightWidget);
    };
    InsightWidgetBuilder.forNew = function (insight) {
        var emptyInsightWidget = {
            description: "",
            drills: [],
            ignoreDashboardFilters: [],
            title: "",
            type: "insight",
            insight: insight,
        };
        return InsightWidgetBuilder.for(emptyInsightWidget);
    };
    return InsightWidgetBuilder;
}(widgetFactory_1.WidgetBaseBuilder));
exports.InsightWidgetBuilder = InsightWidgetBuilder;
/**
 * @alpha
 */
exports.newInsightWidget = function (insight, modifications) {
    return InsightWidgetBuilder.forNew(insight).modify(modifications).build();
};
//# sourceMappingURL=insightWidgetFactory.js.map